import React from "react"

import { withFeaturedImages } from "./withFeaturedImages"
import { Wrapper } from "./FeaturedImagesStyles"
import { Card } from "./Card/Card"

export const FeaturedImages = withFeaturedImages(({ items, cols, gap, ratio }) => (
  <Wrapper cols={cols} gap={gap}>
    {items?.map(item => (
      <Card key={item._key} item={item} ratio={ratio} />
    ))}
  </Wrapper>
))

export default FeaturedImages
